import { createAsyncThunk } from '@reduxjs/toolkit';
import businessProjectsService from 'services/businessProjectsService';
import { RequestParams } from 'utils/mapParams';
import { CreateBusinessProjectParams } from 'models/interfaces/businessProjects.interface';

export const getBusinessProjectsList = createAsyncThunk(
  'businessProjects/getBusinessProjectsList',
  async (params: Partial<RequestParams>, thunkAPI) => {
    try {
      const res = await businessProjectsService.getBusinessProjectsList(params);
      return res;
    } catch (err: any) {
      if (!err.message) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.message.original);
    }
  }
);

export const createBusinessProject = createAsyncThunk(
  'businessProjects/createBusinessProject',
  async (params: CreateBusinessProjectParams, thunkAPI) => {
    const { values, callback } = params;
    try {
      const res = await businessProjectsService.createBusinessProject(values);
      callback();
      return res;
    } catch (err: any) {
      if (!err.message) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.message.original);
    }
  }
);
